<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.5 5.5L12 13L2.5 5.5M4 4H20C20.6667 4 22 4.4 22 6C22 7.6 22 14.6667 22 18C22 18.6667 21.6 20 20 20C18.4 20 8.66667 20 4 20C3.33333 20 2 19.6 2 18C2 16.4 2 9.33333 2 6C2 5.33333 2.4 4 4 4Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: "EmailIcon"
}
</script>

<style scoped>

</style>